import { HttpClient } from '@opallabs/api'
import loadIntegrationTask from '../loadIntegrationTask'

const fetchIntegrationTask = (integrationTaskId) =>
  HttpClient().get(`/integrations/v1/tasks/${integrationTaskId}`)

const getIntegrationTask = (integrationTaskId) => (dispatch) =>
  fetchIntegrationTask(integrationTaskId)
    .then((response) => dispatch(loadIntegrationTask(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getIntegrationTask
